import { PatientDatabaseApi } from '../../../../../api';

let studySitesPromise = null;

function fetchStudySites() {
  if (!studySitesPromise) {
    studySitesPromise = PatientDatabaseApi.getStudySites()
      .then(({ data }) => data)
      .catch(error => {
        studySitesPromise = null;
        throw error;
      });
  }
  return studySitesPromise;
}

export async function getStudySites() {
  const studySites = await fetchStudySites();
  return { studySites };
}

export function cacheCollector(state) {
  return {
    ssu: {
      selectedStudyMap: state?.ssu?.selectedStudyMap,
      selectedSiteMap: state?.ssu?.selectedSiteMap
    },
    therapeuticArea: {
      value: state?.therapeuticArea?.value
    },
    indication: {
      value: state?.indication?.value
    }
  };
}
